import { render, staticRenderFns } from "./LeadPipelineStagePane.vue?vue&type=template&id=2b5e4934&scoped=true"
import script from "./LeadPipelineStagePane.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeadPipelineStagePane.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e4934",
  null
  
)

export default component.exports